/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { createAction, props } from '@ngrx/store';
import { ICloud } from 'generated-types';

const setCloud = createAction(
    '[InfraCloud] Set cloud',
    props<{ cloud: ICloud }>(),
);

export const InfraCloudActions = {
    setCloud,
};
